import {Spin} from "antd";

export default function LoadingPage() {
	return (
		<div style={{
			width: "100%",
			height: "100%",
			display: "flex",
			alignItems: "center",
			justifyContent: "center"
		}}>
			<Spin size="large"/>
		</div>
	)
}
